import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`
// ;

console.log(API_URL, "API_URL")
export const adminCreateApi = async (data) => {
    // console.log(data, "data>>>>>>")
    try {
        const response = await axios.post(
            `${API_URL}auth/admin-create`,
            data
        );
        // console.log(response.data, "response return ")
        return response;
    } catch (error) {
        console.error('Error  creating Admin:', error);
        throw error;
    }
}

export const fetchAdminDetails = async (pageNo = 1, limit = 10) => {
    // console.log(data, "data>>>>>>")
    try {
        const response = await axios.get(`${API_URL}auth/admin-create`, {
      params: { pageNo, limit }, 
    });
        // console.log(response.data, "response return ")
        return response.data;
    } catch (error) {
        console.error('Error  creating Admin:', error);
        throw error;
    }
}

export const deleteAdminDetails = async (data) => {
    try {
        let payload={
            adminId:data
        }
        const response = await axios.delete(
            `${API_URL}auth/admin-create`,
           {  data: payload, }
        );
        return response;
    } catch (error) {
        console.error('Error  creating Admin:', error);
        throw error;
    }
}


export const updateAdminDetails = async (data) => {
    try {
       
        const response = await axios.patch(
            `${API_URL}auth/admin-create`,
           {  data: data}
        );
        return response;
    } catch (error) {
        console.error('Error  update Admin:', error);
        throw error;
    }
}